import { catchError } from 'rxjs/operators/catchError';

/**
  Wrap an epic for error catching so the epic doesn't stop working
  @param epic
  @returns {Observable} Wrapped epic
*/
export default epic => (...args) =>
  epic(...args).pipe(
    // This is so epics don't stop working after a failure
    catchError((error, source) => {
      setTimeout(() => {
        throw error;
      }, 0);
      return source;
    })
  );



// WEBPACK FOOTER //
// ./src/utils/epics/epicWrapper.js